module.exports = __webpack_public_path__ + "img/hood_depth.db048db0.png";